import { render, staticRenderFns } from "./PembagianPopup.vue?vue&type=template&id=c8933f04"
import script from "./PembagianPopup.vue?vue&type=script&lang=js"
export * from "./PembagianPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports